import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.element.style.animationDuration = `${this.element.scrollWidth / 27}s`
  }
}
